import React, { useEffect, useRef, useState } from "react";
import Home from "./pages/Home/Home";
import DishDetails from "./components/DishDetails/DishDetails";
import About from "./pages/About/About";
import Menu from "./pages/Menu/Menu";
import Contact from "./pages/Contact/Contact";
import Navbar from "./components/Navbar/Navbar";
import Signup from "./components/Form/Signup";
import Login from "./components/Form/Login";
import axios from "axios";

import Footer from "./components/Footer/Footer";
import { Route, Routes, useLocation } from "react-router-dom";
import Checkout from "./pages/Checkout/Checkout";
import OrderCompleted from "./components/OrderCompleted/OrderCompleted";
import ScrollToTop from "./components/ScrollToTop";
import ProtectedRoute from "./components/Form/ProtectedRoute";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSelector } from "react-redux";

function App() {
  const [showNav, setShowNav] = useState(false);
  const [dishes, setDishes] = useState([]);
  const location = useLocation();
  const cartItems = useSelector((state) => state.cart.cartItems);
  const prevCartQty = useRef(null);
  const cartReady = useRef(false);

  // ✅ fixed array
  const hideOnRoutes = ["/checkout", "/order-completed", "/login", "/signup"];
  const showNavAndFooter = !hideOnRoutes.includes(location.pathname);

  //CartModal Toggle
  const [isCartModalOpen, setIsCartModalOpen] = useState(false);
  const toggleViewCart = () => {
    setIsCartModalOpen(true);
  };

  useEffect(() => {
    const totalQty = cartItems.reduce((sum, item) => sum + item.qty, 0);

    // Ignore qty changes until persist has settled (avoids cart peaking on mobile load)
    if (!cartReady.current) {
      prevCartQty.current = totalQty;
      return;
    }

    if (prevCartQty.current !== null && totalQty > prevCartQty.current) {
      setIsCartModalOpen(true);
      setShowNav(false);
    }

    if (totalQty === 0) {
      setIsCartModalOpen(false);
    }

    prevCartQty.current = totalQty;
  }, [cartItems]);

  useEffect(() => {
    setIsCartModalOpen(false);
    const timer = setTimeout(() => {
      prevCartQty.current = cartItems.reduce((sum, item) => sum + item.qty, 0);
      cartReady.current = true;
    }, 500);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Close cart on checkout and after order success redirect
  useEffect(() => {
    if (
      location.pathname === "/checkout" ||
      location.pathname === "/order-completed"
    ) {
      setIsCartModalOpen(false);
    }
  }, [location.pathname]);

  useEffect(() => {
    const closeCart = () => setIsCartModalOpen(false);
    window.addEventListener("orderPlaced", closeCart);
    return () => window.removeEventListener("orderPlaced", closeCart);
  }, []);

  //Api
  // Api
  const fetchData = async () => {
    try {
      const API_BASE_URL = process.env.REACT_APP_API_URL;
      const response = await axios.get(`${API_BASE_URL}/api/dishes`);

      if (Array.isArray(response.data)) {
        setDishes(response.data);
      } else {
        console.error("Unexpected API response:", response.data);
        setDishes([]);
      }
    } catch (error) {
      console.error("Error fetching dishes:", error);
    }
  };

  useEffect(() => {
    fetchData();

    window.addEventListener("userLoggedIn", fetchData);
    return () => window.removeEventListener("userLoggedIn", fetchData);
  }, []);

  useEffect(() => {
    document.body.style.overflow = showNav ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [showNav]);

  return (
    <div className="App">
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        theme="colored"
      />
      <ScrollToTop />
      {showNavAndFooter && (
        <Navbar
          showNav={showNav}
          setShowNav={setShowNav}
          toggleViewCart={toggleViewCart}
          isCartModalOpen={isCartModalOpen}
          setIsCartModalOpen={setIsCartModalOpen}
        />
      )}
      <div className="">
        <Routes>
          <Route exact path="/" element={<Home dishes={dishes} />} />
          <Route
            exact
            path="/menu/:id"
            element={<DishDetails singleDish={dishes} />}
          />
          <Route exact path="/about" element={<About />} />
          <Route exact path="/menu" element={<Menu dishes={dishes} />} />
          <Route exact path="/contact" element={<Contact />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/order-completed" element={<OrderCompleted />} />
          <Route
            exact
            path="/:id"
            element={<DishDetails singleDish={dishes} />}
          />
          <Route
            path="/checkout"
            element={
              <ProtectedRoute>
                <Checkout />
              </ProtectedRoute>
            }
          />{" "}
        </Routes>
      </div>
      {showNavAndFooter && <Footer />}
    </div>
  );
}

export default App;
